<template>
  <div class="auth">
    <validation-observer ref="loginForm" #default="{ invalid }">
      <b-form class="auth-login-form mt-2" @submit.prevent="login">
        <b-form-group label="موبایل یا ایمیل" label-for="login-userName">
          <validation-provider
            #default="{ errors }"
            name="userName"
            rules="required|mobileEmail"
          >
            <b-form-input
              autocomplete="on"
              id="login-userName"
              v-model="userName"
              :state="errors.length > 0 ? false : null"
              name="login-userName"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <b-form-group>
          <validation-provider
            #default="{ errors }"
            name="Password"
            vid="password"
            rules="required|min:6|notArabic"
          >
            <label for="login-password">رمز عبور</label>

            <b-input-group
              class="input-group-merge"
              :class="errors.length > 0 ? 'is-invalid' : null"
            >
              <b-form-input
                autocomplete="on"
                id="login-password"
                v-model="password"
                :state="errors.length > 0 ? false : null"
                class="form-control-merge"
                :type="passwordFieldType"
                name="login-password"
                placeholder="············"
              />
              <b-input-group-append is-text>
                <feather-icon
                  class="cursor-pointer"
                  :icon="passwordToggleIcon"
                  @click="togglePasswordVisibility"
                />
              </b-input-group-append>
            </b-input-group>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>

        <div class="d-flex justify-content-between my-2">
          <b-link @click="$emit('')">
            <small>فراموشی رمز عبور</small>
          </b-link>
        </div>
        <b-button type="submit" variant="primary" block :disabled="invalid">
          ورود
        </b-button>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BCard,
  BAlert,
} from "bootstrap-vue";
import {
  required,
  mobileEmail,
  notArabic,
} from "@/@core/utils/validations/validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BAlert,
    ValidationProvider,
    BCard,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: "",
      password: "",
      userName: "",
      loading: false,
      required,
      mobileEmail,
      notArabic,
    };
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },

    device() {
      return this.$store.state.appConfig.device;
    },
  },
  methods: {
    async login() {
      this.$refs.loginForm.validate().then(async (success) => {
        if (success) {
          this.loading = true;
          try {
            const { data } = await this.$http.post("/auth/login", {
              username: this.userName,
              password: this.password,
              device_name: this.device,
            });
            this.$http.defaults.headers.common["Authorization"] =
              await `${data.data.type} ${data.data.token}`;
            await localStorage.setItem(
              "userData",
              JSON.stringify(data.data.user)
            );
            await this.$store.dispatch("auth/setUserData", data.data.user);
            await localStorage.setItem(
              "token",
              JSON.stringify({ val: data.data.token, type: data.data.type })
            );
            // const isAdmin =
            //   (await data.data.user.permissions.permissions.length) > 0;
            // await this.$store.commit(
            //   "appConfig/UPDATE_NAV_MENU_HIDDEN",
            //   !isAdmin
            // );
            if (!data.data.user.mobile_verified_at) {
              this.$store.dispatch("auth/setVisibleCheckUser", true);
              this.$store.dispatch("auth/setVerifyType", "mobile");
            }
            if (!data.data.user.email_verified_at) {
              this.$store.dispatch("auth/setVisibleCheckUser", true);
              this.$store.dispatch("auth/setVerifyType", "email");
            }
            this.loading = false;
            this.$router.replace("/").then(() => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: ` ${
                    data.data.user.first_name + " " + data.data.user.last_name
                  } خوش آمدید.`,
                  icon: "CoffeeIcon",
                  variant: "success",
                },
              },
              { position: "bottom-right" });
            });
          } catch (err) {
            this.loading = false;
          }
        }
      });
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
.auth {
  .input-group-text {
    height: auto !important;
    border: 1px solid #d8d6de !important;
  }
}
</style>
